import React, { useEffect, useState } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import PatientRegister from "./PatientRegister";
import "./Newprofile.css";

/**
 * Patient Information page wrapper.
 *
 * IMPORTANT:
 * PatientRegister is the component responsible for loading/saving patient data.
 * The old Newprofile component also called get.php through fetchRecords(), even
 * though those legacy records were never rendered. That duplicate request was
 * the source of the "Unexpected end of JSON input" runtime error.
 */
export default function Newprofile() {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setOpen(window.innerWidth >= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div style={{ minHeight: "100vh" }}>
            <div
                className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
                style={{
                    zIndex: 999,
                    cursor: "pointer",
                    position: "fixed",
                    left: open ? "350px" : "60px",
                    top: "0",
                    transition: "left 0.3s ease"
                }}
                onClick={() => setOpen(!open)}
            >
                <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
                    ☰
                </span>
            </div>

            <div className="d-flex" style={{ minHeight: "100vh" }}>
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease",
                        flexShrink: 0
                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        minWidth: 0
                    }}
                >
                    <TopBanner />
                    <PatientRegister />
                </div>
            </div>
        </div>
    );
}
